export default __webpack_public_path__ + "static/media/029-unicycle.db590d40.svg";